module.exports = __webpack_public_path__ + "img/uid-token-login.171c1bee.png";